module.exports = __webpack_public_path__ + "static/media/updated_training_library.50cd346e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/updated_training_library.svg
// module id = 2725
// module chunks = 0